import { TeContainerSlim, TePlaceholder, TeText } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';

import type { EulaResult } from './useEula';
import { GetEULAStatus } from '../../api/ExperienceFragment/query';

const EulaContent = ({ content, status, error }: EulaResult) => {
  const { t } = useTranslation('common');
  const domains = content?.domains ?? [];

  if ((status === GetEULAStatus.LOADING || status === GetEULAStatus.IDLE) && !content) {
    return (
      <TeContainerSlim column gap="m" height={400} width={700}>
        <TePlaceholder height={20} />
        <TePlaceholder height={50} />
        <TePlaceholder height={20} />
        <TePlaceholder height={300} />
      </TeContainerSlim>
    );
  }

  if (error && !content) {
    return (
      <TeText size={14} color="text.secondary">
        {t('eula.errorLoading')}
      </TeText>
    );
  }

  if (!content || domains.length === 0) {
    return (
      <TeText size={14} color="text.secondary">
        {t('eula.unavailableData')}
      </TeText>
    );
  }

  return (
    <TeContainerSlim column gap="l">
      {domains.map((domain, domainIdx) => (
        <TeContainerSlim
          key={domain.key ? `${domain.key}-${domain.ordinal}` : domainIdx}
          column
          gap="s"
        >
          {domain.title && (
            <TeText size={16} weight={700} color="text.primary">
              {domain.title}
            </TeText>
          )}

          {domain.intro.length > 0 && (
            <TeContainerSlim column gap="m">
              {domain.intro.map((paragraph, index) => (
                <TeContainerSlim key={index} gap="xs" column>
                  {paragraph.title && (
                    <TeText size={14} weight={600} color="text.primary">
                      {paragraph.title}
                    </TeText>
                  )}

                  {paragraph.text && (
                    <TeText size={14} weight={400} color="text.primary">
                      {paragraph.text}
                    </TeText>
                  )}
                </TeContainerSlim>
              ))}
            </TeContainerSlim>
          )}

          {domain.sections.map((section, idx) => (
            <TeContainerSlim key={`${section.number}-${section.title ?? idx}`} column gap="m">
              <TeText size={16} weight={700} color="text.primary">
                {section.title ? `${section.number}. ${section.title}` : `${section.number}.`}
              </TeText>
              {section.paragraphs.map((paragraph, index) => (
                <TeContainerSlim key={index} gap="m" fill>
                  <TeContainerSlim style={{ minWidth: 70 }}>
                    <TeText size={14} weight={400} color="text.primary">
                      {paragraph.number}
                    </TeText>
                  </TeContainerSlim>
                  <TeContainerSlim grow>
                    <TeText size={14} weight={400}>
                      {paragraph.text}
                    </TeText>
                  </TeContainerSlim>
                </TeContainerSlim>
              ))}
            </TeContainerSlim>
          ))}
        </TeContainerSlim>
      ))}
    </TeContainerSlim>
  );
};

export default EulaContent;
